import { UPDATE_USER_REF, UPDATE_USER_REF_SUCCESS, UPDATE_USER_REF_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
};

const updateUserRefReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_USER_REF:
      return { ...state, loading: true };
    case UPDATE_USER_REF_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_USER_REF_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default updateUserRefReducer;
